import { ACTION } from "@/lib/auth/actions";
import { hasPermission } from "@/lib/authv2/permissions";

/** Bản sao cổng backend `auth.Allow("certgate.read")` — xem cấu hình, phủ, hộp thư. */
export const canReadCertgate = () => hasPermission(ACTION.CertgateRead);
/** `certgate.config.write` — đổi chế độ TẮT/NHẮC/CHẶN, sửa ánh xạ dòng. */
export const canEditCertGate = () => hasPermission(ACTION.CertgateConfigWrite);
/** `certgate.exception` — gán người thiếu chứng chỉ ở chế độ CHẶN kèm lý do. */
export const canGrantCertException = () => hasPermission(ACTION.CertgateException);
